export const CORE_VALUES = [
    'Simplicity',
    'Innovation',
    'Magnanimity',
    'Perseverance',
    'Loyalty',
    'Efficiency',

]